import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { UIService } from '../../../shared/services/UIService';


@Component({
    templateUrl: './glossary.page.html',
})

export class GlossaryPage extends BasePage {

    items: any[] = [
        {
            title: "Publish",
            name: "publish",
            icon: "icon-globe"
        }
    ]

    constructor(public router: Router, serviceCaller: ServiceCaller, public ui: UIService) {
        super(serviceCaller);
    }

    onMenuItemClick(e) {
        switch (e.name) {
            case "publish":
                {
                    this.ui.confirm("Publish", "Are you sure you want to publish items?").then(() => {
                        this.api.post("/Dictionary/Generate").then(c => {
                            this.ui.success();
                            this.ui.confirm("Download", "Do you want to download the generated file?").then(() => {
                                debugger;
                                for (const key in c) {
                                    if (c.hasOwnProperty(key)) {
                                        const element = c[key];
                                        let json = JSON.stringify(element);
                                        let thefile = new Blob([json], { type: "application/json" });
                                        var link = document.createElement('a');
                                        link.href = window.URL.createObjectURL(thefile);
                                        link.download = `strings.${key}.json`;
                                        link.click();
                                    }
                                }
                            
                            });
                        });
                    });
                    break;
                }
        }
    }

    onEditorPreparing(e) {
        if (e.row && e.row.rowType === "data" && e.dataField == "Name" && !e.row.inserted) {
            e.editorOptions.readOnly = true;
        }
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Settings/glossary.page.ts